<template>
	<div>
		<b-form-radio-group
			:options="options"
			v-model="proxyValue"
			button-variant="outline-primary"
			stacked
			buttons
			:state="state"
			@change="change"
			:disabled="!active"
		>
		</b-form-radio-group>

		<b-form-invalid-feedback :id="`${name}-feedback`">
			{{ errors[name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	props: {
		options: {
			type: Array,
			required: true
		},
		value: {
			required: false
		},
		name: {
			type: String
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		state: {
			type: Boolean
		}
	},

	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
			}
		}
	},

	methods: {
		change(newValue) {
			this.$emit("change", newValue);
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		}
	},
	data() {
		return {
			active: true
		};
	},
	beforeMount() {
		if (typeof this.isActive == "function") this.active = this.isActive(null);
		else this.active = this.isActive;
	}
};
</script>

<style scoped>
.btn {
	margin-top: 5px !important;
}
</style>
